import type { IconProps } from '../types/IconProps.ts';
export const Link2Off: IconProps = {
    name: 'Link2Off',
    children: [
        `<path d="M17 17a5 5 0 0 0 0-10h-1M8 17H7A5 5 0 0 1 7 7M7 12h5M2 2l20 20" />`,
    ]
};